/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowBeachDayTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowBeachDay,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Fun in the Sun!",
    "Beach Bash Awaits!",
    "Let’s Hit the Waves!",
  ],
  title: "Beach Day",
  description: "Organize a fun day at the beach.",
  longDescription:
    "Gather your friends for a relaxing day at the beach! Choose a date, decide on activities, and plan refreshments to enjoy!",
  emoji: "🏖",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Beach Day",
          emoji: "🏖",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go to the beach?",
          emoji: "📅",
          completeAction: {
            question: "Decide on beach activities?",
            description: "What activities do we want to do at the beach?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we plan?",
                emoji: "🏄",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we bring for our beach day?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍉",
                    },
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What drinks should we have?",
                      emoji: "🍹",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Sun, Sand, and Fun!",
    outroDescription: "Your beach day plans are set! Enjoy the sun and waves!",
  },
};
